import {
  CANCEL_SUBSCRIPTION_MODAL_STEPS,
  useCancelSubscriptionContext,
} from "@/features/billing/context";
import { CancellationDiscountModal } from "./cancellation-discount-modal";
import { CancellationEmailSentModal } from "./cancellation-email-sent-modal";
import { CancellationFarewellModal } from "./cancellation-farewell-modal";
import { CancellationReasonsModal } from "./cancellation-reasons-modal";

const modalSteps = {
  [CANCEL_SUBSCRIPTION_MODAL_STEPS.REASONS]: CancellationReasonsModal,
  [CANCEL_SUBSCRIPTION_MODAL_STEPS.DISCOUNT]: CancellationDiscountModal,
  [CANCEL_SUBSCRIPTION_MODAL_STEPS.EMAIL_SENT]: CancellationEmailSentModal,
  [CANCEL_SUBSCRIPTION_MODAL_STEPS.FAREWELL]: CancellationFarewellModal,
} as const;

export const CancelSubscriptionModals = () => {
  const {
    currentModal,
    show,
    actions: { onClose },
  } = useCancelSubscriptionContext();

  const Modal = modalSteps[currentModal];

  return <Modal open={show} onOpenChange={onClose} />;
};
